import { Component, Input, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FormGroupComponent, InputComponent } from '@tecalisdev/infinity';

import { ReactiveFormsService } from '../../../../shared/services/reactive-forms.service';
import {
	FORM_STEP_FIELD_TITLE_ANCHOR_ID,
	formStepFieldTitleErrorMessage,
	formStepFieldTitleHasError,
} from '../form-step-field-title.util';

@Component({
	selector: 'app-form-step-field-title-config',
	imports: [ReactiveFormsModule, TranslatePipe, FormGroupComponent, InputComponent],
	templateUrl: './form-step-field-title-config.component.html',
})
export class FormStepFieldTitleConfigComponent {
	public reactiveFormService = inject(ReactiveFormsService);
	private trans = inject(TranslateService);

	@Input({ required: true }) fieldGroup!: FormGroup;
	@Input() selectedLocaleId = 'es';
	@Input() titleRequired = false;

	public readonly fieldTitleAnchorId = FORM_STEP_FIELD_TITLE_ANCHOR_ID;

	public get fieldTitleLabel(): string {
		const label = this.trans.instant('WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELD_TITLE');
		return this.titleRequired ? `${label}*` : label;
	}

	public get titleControl(): FormControl {
		return this.fieldGroup.get('title')?.get(this.selectedLocaleId) as FormControl;
	}

	public fieldTitleHasError(): boolean {
		return formStepFieldTitleHasError(this.reactiveFormService, this.fieldGroup, this.selectedLocaleId);
	}

	public fieldTitleErrorMessage(): string {
		return formStepFieldTitleErrorMessage(
			this.reactiveFormService,
			this.fieldGroup,
			this.selectedLocaleId,
			this.trans.instant('ERRORS.REQUIRED'),
		);
	}
}
